import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-blog-mobile',
  templateUrl: './blog-mobile.component.html',
  styleUrls: ['./blog-mobile.component.css']
})
export class BlogMobileComponent implements OnInit {

  rawv1mi: string = ' '
  rawrarh: string = ' '
  rawkht2: string = ' '
  rawtakj: string = ' '
  rawznx0: string = ' '
  constructor(private title: Title, private meta: Meta) {
    this.title.setTitle('Mobile-Blog - Conventional Parallel Rook')
    this.meta.addTags([
      {
        property: 'og:title',
        content: 'Mobile-Blog - Conventional Parallel Rook',
      },
    ])
  }

  ngOnInit() {
  }

}
